import { serverPostRequest } from '../utilsServices';
import { wrapAutosuggestForLegacyUI } from '../util/autosuggest';

const DATA_WAREHOUSE_SECURE_BASE_URL = `${ process.env.REACT_APP_MS_DATAWAREHOUSE_SECURE }`;
const SJM_SECURE_BASE_URL = `${ process.env.REACT_APP_MS_SPONSORED_JOB_META_SECURE }`;

// MS = Data Warehouse
export const getPublisherAutosuggestJF = serverPostRequest(`${ DATA_WAREHOUSE_SECURE_BASE_URL }publisher/autosuggest`);

// MS = Sponsored Job Meta (SJM)
export const getOrganizationAutosuggestJF = serverPostRequest(`${ SJM_SECURE_BASE_URL }organizationJobFeed/autosuggest`);
export const getHiringCompanyAutosuggestJF = serverPostRequest(`${ SJM_SECURE_BASE_URL }hiringCompanyJobFeed/autosuggest`);
export const getCompanyAutosuggestJF = serverPostRequest(`${ SJM_SECURE_BASE_URL }companyJobFeed/autosuggest`);
export const getJobGroupAutosuggestJF = serverPostRequest(`${ SJM_SECURE_BASE_URL }jobGroupJobFeed/autosuggest`);


// Legacy UI compatible autosuggest functions
export const getOrgAutosuggestJFLegacy = wrapAutosuggestForLegacyUI(getOrganizationAutosuggestJF);
export const getHiringCompanyAutosuggestJFLegacy = wrapAutosuggestForLegacyUI(getHiringCompanyAutosuggestJF);
export const getCompanyAutosuggestJFLegacy = wrapAutosuggestForLegacyUI(getCompanyAutosuggestJF);
export const getJobGroupAutosuggestJFLegacy = wrapAutosuggestForLegacyUI(getJobGroupAutosuggestJF);
export const getPublisherAutosuggestJFLegacy = wrapAutosuggestForLegacyUI(getPublisherAutosuggestJF);
